import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class Product
 * @exports Service/Cms/ProductUpdate
 * @description API ProductUpdate Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class ProductUpdate {
	/**
	 * @static @name post
	 * @description List all product updates
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static list(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			`cms/product-updates/list`,
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-product-updates-${cacheHash}`
			}
		);
	}
}
